/* Tab switcher for custom-hpb-shop-by-tabs.liquid (Homepage B, "Shop rugs by").
   Buttons carry data-hpt-tab="<key>"; panels carry data-hpt-panel="<key>". */
if (!customElements.get('custom-hpb-tabs')) {
  class CustomHpbTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-hpt-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-hpt-panel]'));
      if (!this.tabs.length) return;
      this.tabs.forEach((btn) => {
        btn.addEventListener('click', () => this.show(btn.dataset.hptTab));
      });
      this.show(this.tabs[0].dataset.hptTab);
    }

    show(key) {
      this.tabs.forEach((btn) => {
        const active = btn.dataset.hptTab === key;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((p) => {
        p.hidden = p.dataset.hptPanel !== key;
      });
    }
  }
  customElements.define('custom-hpb-tabs', CustomHpbTabs);
}
